import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
declare let Croppie: any;
@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.page.html',
  styleUrls: ['./image-cropper.page.scss'],
})
export class ImageCropperPage implements OnInit {

    src = "assets/images/avatar.png";
    c = null;
    constructor(private modalController: ModalController, private navParams: NavParams) {
        this.src = this.navParams.get("src");
    }

    startResize() {
        var myImage = new Image();
        myImage.src = this.src;
        myImage.onload = function () { };
    }
    ngOnInit() {
        this.c = new Croppie(document.getElementById('cropperImage'), {
            maxZoomedCropWidth:400,
            viewport: {
                width: 80,
                height: 130,
                type:"square"
            },
            showZoomer: true,
            enableOrientation: true
        });
        this.c.bind({
            url: this.src
        }).then(function () {
            var cr = document.getElementsByClassName('cr-slider');
            var sl = cr[0] as HTMLInputElement;
            console.log(sl);
            console.log(sl.value);
            //sl.value = '0.5';
            var event = new Event('change');
            sl.dispatchEvent(event);
            //console.log(sl.value);
           // this.c.setZoom('0.1');
            });
       
    }
    ok() {
        var that = this;
        this.c.result('base64').then(function (blob) {
            that.modalController.dismiss(blob);
        });
    }

}
